import first from "lodash/first";
import { forwardRef } from "react";
import { graphql, useFragment } from "react-relay";

import { BaseImage } from "~/components/common/base-image";
import type { ContentItemRenderVariantProps } from "~/components/content/content-item-render/types";
import type { homeMultimediaPodcastContentItemContent$key } from "~/queries/__generated__/homeMultimediaPodcastContentItemContent.graphql";

import { Container, Content, Headline, Label, StyledEntityLink, StyledFigure } from "./styles";

export type Props = {
  reference: homeMultimediaPodcastContentItemContent$key;
} & ContentItemRenderVariantProps;

export const ContentItemHomeMultimediaPodcast = forwardRef<HTMLDivElement, Props>(
  ({ className, onClick, provider, reference: reference_ }, reference) => {
    const content = useFragment(
      graphql`
        fragment homeMultimediaPodcastContentItemContent on Content {
          entityId
          ... on Article {
            images {
              style(filter: { style: "100x100" }) {
                url
              }
            }
          }
          ... on Podcast {
            podcastSections {
              images {
                style(filter: { style: "100x100" }) {
                  url
                }
              }
              name
            }
          }
          ...entityLink
        }
      `,
      reference_,
    );

    const firstPodcastSection = first(content?.podcastSections);
    const sectionName = firstPodcastSection?.name ?? "";
    const podcastImageUrl = first(firstPodcastSection?.images)?.style?.url ?? "";
    const articleImageUrl = first(content?.images)?.style?.url ?? "";
    const imageUrl = podcastImageUrl || articleImageUrl;

    return (
      <Container className={className} ref={reference}>
        <StyledEntityLink reference={content} onClick={() => onClick?.(content.entityId)}>
          <Content>
            <Label>PODCAST</Label>
            <Headline>
              {provider.headline({ hideTooltip: true, preferSocialHeadline: true })}
            </Headline>
          </Content>
          <StyledFigure $aspectRatio="1/1">
            <BaseImage
              $aspectRatio="1/1"
              $objectFit="cover"
              alt={sectionName}
              src={imageUrl}
              lazyload
            />
          </StyledFigure>
        </StyledEntityLink>
      </Container>
    );
  },
);

ContentItemHomeMultimediaPodcast.displayName = "ContentItemHomeMultimediaPodcast";
